var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-breadcrumb',_vm._b({staticClass:"app-breadcrumb breadcrumb-new"},'b-breadcrumb',{..._vm.$props, ..._vm.$attrs},false))
}
var staticRenderFns = []

export { render, staticRenderFns }